import { Fragment, useEffect } from 'react';
import { history, IRouteComponentProps } from 'umi';
import { BackButton } from '@/components/back-button/back-button';
import { useSelector } from 'dva';
// import PcContext from '@/utils/context';
import PolicyDetail from '@/components/policy-detail/policy-detail';
import { getPoliciesDetail, getPolicyDetailConfig } from '../../service';
import SkeletonLoading from '@/components/skeleton-loading';
import '../style/policies-list.less';
import throttle from 'lodash/throttle';
import { useState } from 'react';

const CustomerPolicyDetailPage = ({ location }: IRouteComponentProps) => {
  const { query } = location;
  // const isPc = useContext(PcContext);
  const { currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );
  const [isLoading, setLoading] = useState<boolean>(false);
  const [policyDetail, setPolicyDetail] = useState<any>();
  const [policyDetailConfig, setPolicyDetailConfig] = useState<any>();

  const handleGetPoliciesDetail = throttle(
    async () => {
      try {
        setLoading(true);
        getPoliciesDetail({ id: query.id })
          .then((res) => {
            if (res) {
              setPolicyDetail(res.policy);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        setLoading(false);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  const handleGetPoliciesDetailConfig = throttle(
    async () => {
      try {
        setLoading(true);
        getPolicyDetailConfig({
          product_type: query.product_type,
          product_key: query.product_key,
          plan_key: query.plan_key,
        })
          .then((res) => {
            if (res) {
              setPolicyDetailConfig(res.config);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        setLoading(false);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  useEffect(() => {
    handleGetPoliciesDetailConfig();
    handleGetPoliciesDetail();
  }, []);

  return (
    <Fragment>
      <BackButton handleClick={() => history.goBack()} />
      <div style={{ marginBottom: '100px' }}>
        {!isLoading ? (
          policyDetail &&
          policyDetailConfig && (
            <PolicyDetail
              policyDetail={policyDetail}
              currentLang={currentLang}
              policyDetailConfig={policyDetailConfig}
            />
          )
        ) : (
          <div style={{ marginTop: '45px' }}>
            <SkeletonLoading />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CustomerPolicyDetailPage;
